/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Confirm_Return_Col_DeductedInputs */

const vi_confirm_return_col_deducted = /** @type {(inputs: Confirm_Return_Col_DeductedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ĐÃ TRỪ`)
};

/**

* @param {Confirm_Return_Col_DeductedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const confirm_return_col_deducted = /** @type {((inputs?: Confirm_Return_Col_DeductedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_Return_Col_DeductedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_confirm_return_col_deducted(inputs)
});